import React from 'react';
import { Alert } from 'react-bootstrap';
import FlairIcon from '../../../../../../atomic/atoms/FlairIcon';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';

type ServerValidationAlertProps = {
  error: string | null;
};

export const ServerValidationAlert: React.FC<ServerValidationAlertProps> = ({
  error,
}) => {
  const t = useNamespacedTranslation('changeRequests.requestForm.validation');

  if (error === null) return null;

  return (
    <Alert variant="danger" className="mb-3 d-flex align-items-start">
      <FlairIcon icon="alert-circle-outline" size="sm" className="me-2 mt-1" />
      <div>
        <div className="fw-bold mb-1" style={{ fontSize: '0.875rem' }}>
          {t('title')}
        </div>
        <div className="mb-0">{error}</div>
      </div>
    </Alert>
  );
};
